import {
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   WikiLink,
   CustomHeading,
   History,
   CustomBulletList,
   CustomOrderedList,
   CustomListItem,
   Blockquote,
   CustomMention,
   CodeBlock,
   MediaManager,
   CustomHardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   Video,
   FeaturedQuote,
   Note,
} from '../extensions';
import { MenuSeparator } from '../components/MenuSeparator';
import { TiptapMenubar } from '../components/TiptapMenubar';
import { TextStyleDropdown } from '../components/TextStyleDropdown';
import { VideoInsertDropdown } from '../components/VideoInsertDropdown';
import {
   BoldButton,
   ItalicButton,
   CodeButton,
   LinkButton,
   CodeBlockButton,
   BlockquoteButton,
   NoteDropdown,
   BulletListButton,
   OrderedListButton,
   IndentButton,
   UnindentButton,
   UndoButton,
   RedoButton,
   InsertImageButton,
} from '../components/buttons';
import type { TiptapExtension } from '.';

export const AnswersExtensions: Array<TiptapExtension> = [
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   WikiLink,
   CustomHeading,
   History,
   CustomBulletList,
   CustomOrderedList,
   CustomListItem,
   Blockquote,
   CustomMention,
   CodeBlock,
   MediaManager,
   CustomHardBreak,
   CustomSubscript,
   CustomSuperscript,
   CustomUnderline,
   Video,
   FeaturedQuote,
   Note,
];

export const AnswersMenuBar = () => (
   <TiptapMenubar>
      <BoldButton />
      <ItalicButton />
      <CodeButton />
      <LinkButton />
      <MenuSeparator />
      <TextStyleDropdown />
      <MenuSeparator />
      <CodeBlockButton />
      <BlockquoteButton />
      <NoteDropdown />
      <BulletListButton />
      <OrderedListButton />
      <UnindentButton />
      <IndentButton />
      <MenuSeparator />
      <InsertImageButton />
      <VideoInsertDropdown />
      <MenuSeparator />
      <UndoButton />
      <RedoButton />
   </TiptapMenubar>
);
